<template>
  <div class="grid-9 grid-column-gap-0">
    <div class="sidebar-wrapper span-2">
      <slot></slot>
    </div>
    <div v-if="loaded && userContext" class="span-6 col-4 span-9-sm span-9-md">
      <div id="balance-sdk"></div>
      <h3 class="h3-new">Credit Details</h3>
      <div class="mt-40 grid-12 grid-column-gap-30">
        <div class="span-5">
          <div class="subheading-3 mb-8">net terms:</div>
          <div>{{ netTerms }}</div>
        </div>
        <div class="span-6 col-7">
          <div class="subheading-3 mb-8">Credit available:</div>
          {{ creditAvailable }}
        </div>
      </div>
      <div
        v-if="showApplyForCredit"
        class="bg-light-green mt-40 p-40"
      >
        <h3 class="font-size-32 mb-8">Apply for Net-60 Terms</h3>
        <p class="b1">
          We offer net-60 terms to all qualified retailers, meaning you’ll be able to sell your inventory for 2 full months before paying your invoice. Click the button to apply: you’ll securely link your bank account so we can determine your terms.
        </p>
        <bulletin-button
          @click="handleClick"
          class="mt-20"
          :variant="'primary'"
        >
          Apply Now
        </bulletin-button>
      </div>
      <div
         v-if="showIncrease"
        class="bg-light-green mt-40 p-40"
      >
        <h3 class="font-size-32 mb-8">Increase Your Credit</h3>
        <p class="b1">
          Connect your account to increase your Net-60 credit limit.
        </p>
        <bulletin-button
          @click="handleIncreaseClick"
          class="mt-20"
          :variant="'primary'"
        >
          Apply Now
        </bulletin-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import balanceApi from "@/services/api/balanceApi";

const balanceApiService = new balanceApi();

// qualification_status": "NOT_APPLIED

export default {
  name: "credit",
  data: function() {
    return {
      loaded: false,
      netTerms: null,
      creditAvailable: null,
      net60: `Net 60 - Charged 60 days from when your products are shipped`,
      net0: "Net 0 - Charged when your products are shipped",
      qualificationStatus: null,
      showIncrease: false,
    };
  },
  computed: {
    ...mapGetters({
      userContext: "userContext"
    }),
    showApplyForCredit() {
      return this.qualificationStatus !== "DECLINED" &&
        this.qualificationStatus !== "APPROVED" &&
        this.userContext.balance_id !== null &&
        this.userContext.use_balance;
    }
  },
  async mounted() {
    if (this.userContext) {
      await this.getBalance();
      this.loaded = true;
    }
  },
  watch: {
    "userContext": async function() {
      await this.getBalance();
      this.loaded = true;
    }
  },
  methods: {
    async getBalance() {
      const isABalanceUser = this.userContext.balance_id !== null && this.userContext.use_balance;
      if (isABalanceUser) {
        const { data:buyerData } = await balanceApiService.getBuyer();
        const { data:creditLimit } = await balanceApiService.getBuyerCreditLimit(this.userContext.balance_id);
        const isApproved = creditLimit.status === "APPROVED";
        this.showIncrease = buyerData.paymentData.banks.length === 0 && buyerData.qualificationStatus === 'completed';
        this.qualificationStatus = creditLimit.status;
        this.netTerms = isApproved ? this.net60 : this.net0;
        this.creditAvailable = isApproved ? `${this.$utils.toDollars(creditLimit.creditLimit)} of ${this.$utils.toDollars(creditLimit.maxCreditLimit)}` : "$0";
      } else {
        this.isQualified = false;
        this.netTerms = this.net60;
        this.creditAvailable = `$${this.userContext.credit_left}  of  $${this.userContext.credit_level}`;
      }

      this.configureBalanceEvents();
    },
    async handleClick() {
      const { data } = await balanceApiService.getSignupLink(this.userContext.balance_id);
      location.href = data;
    },
    async handleIncreaseClick() {
      const {data} = await balanceApiService.getBuyerToken();
      window.balanceSDK.paymentMethod.render(data.token, "#balance-sdk");
    },
    async configureBalanceEvents() {
      window.balanceSDK.paymentMethod.init({
        allowedPaymentMethods: ["achDebit"],
        onSuccess: async () => {
          await this.getBalance();
        },
        onError: function() {},
        onClose: async () => {},
        onCancel: function() {}
      });
    },
  }
};
</script>

<style>
#balance-sdk > div {
  z-index: 2147483646;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>

